module.exports = __webpack_public_path__ + "static/media/orchestra.3b3621ee.jpg";